import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Alert from "react-bootstrap/Alert";
import "./Singup.css";

export default function Signup() {

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
        confirmPassword: ""
    });

    const [success, setSuccess] = useState(false);

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });

    };

    const handleSignup = (e) => {

        e.preventDefault();

        // Check empty fields

        if (
            !formData.name ||
            !formData.email ||
            !formData.password ||
            !formData.confirmPassword
        ) {

            alert("⚠️ Please fill all fields!");

            return;
        }

        // Check password

        if (
            formData.password !==
            formData.confirmPassword
        ) {

            alert("❌ Passwords do not match!");

            return;
        }

        // Create user

        const user = {

            name: formData.name,

            email: formData.email,

            password: formData.password

        };

        // Save user

        localStorage.setItem(
            "user",
            JSON.stringify(user)
        );

        // Clear old login

        localStorage.removeItem(
            "isLoggedIn"
        );

        localStorage.removeItem(
            "userEmail"
        );

        // Success

        setSuccess(true);

        // Go to Login

        setTimeout(() => {

            navigate("/login");

        }, 1500);

    };

    return (

        <div className="signup-page">

            <Container className="signup-container">

                <h2>
                    Create Account
                </h2>

                <p>
                    Sign up to start ordering
                    from Srineevi Coffee House ☕
                </p>


                {/* SUCCESS MESSAGE */}

                {success && (

                    <Alert variant="success">

                        🎉 Signup Successful!

                        <br />

                        Redirecting to Login...

                    </Alert>

                )}


                {/* SIGNUP FORM */}

                <form onSubmit={handleSignup}>

                    {/* NAME */}

                    <input
                        id="signup-name"
                        name="name"
                        type="text"
                        placeholder="Full Name"
                        className="input-box"
                        value={formData.name}
                        onChange={handleChange}
                        autoComplete="name"
                        required
                    />


                    {/* EMAIL */}

                    <input
                        id="signup-email"
                        name="email"
                        type="email"
                        placeholder="Email"
                        className="input-box"
                        value={formData.email}
                        onChange={handleChange}
                        autoComplete="email"
                        required
                    />


                    {/* PASSWORD */}

                    <input
                        id="signup-password"
                        name="password"
                        type="password"
                        placeholder="Password"
                        className="input-box"
                        value={formData.password}
                        onChange={handleChange}
                        autoComplete="new-password"
                        required
                    />


                    {/* CONFIRM PASSWORD */}

                    <input
                        id="signup-confirm-password"
                        name="confirmPassword"
                        type="password"
                        placeholder="Confirm Password"
                        className="input-box"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        autoComplete="new-password"
                        required
                    />


                    {/* SIGN UP BUTTON */}

                    <button
                        type="submit"
                        className="button-box"
                    >
                        Sign Up
                    </button>

                </form>


                {/* LOGIN */}

                <p
                    className="signup-login-text"
                    style={{
                        marginTop: "20px",
                        textAlign: "center"
                    }}
                >

                    Already have an account?{" "}

                    <span
                        style={{
                            color: "#0d6efd",
                            cursor: "pointer",
                            fontWeight: "bold"
                        }}
                        onClick={() =>
                            navigate("/login")
                        }
                    >
                        Sign In
                    </span>

                </p>

            </Container>

        </div>

    );
}